import React, { forwardRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const PrintLevelLabels = forwardRef(({ data = [] }, ref) => {
    return (
        <div ref={ref}>
            {data.map((item, i) => (
                <div key={item.id || `${item.code}-${i}`} 
                    style={{
                        width: "101mm",
                        height: "53mm",
                        pageBreakAfter: "always",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="print-item flex items-center p-2 relative">
                        <QRCodeCanvas value={item.code} size={120} />

                        <div className="ml-2 text-xs font-bold bg-white px-1 rounded text-right">
                            {item.code}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
});

export default PrintLevelLabels;